import {
  getImageSizeFailure,
  getImageSizeRequest,
  getImageSizeResponse
} from 'app/CanvasComponent/actions';

/**
 * fetch image sizes
 * @param {string} componentId - id of the component
 * @param {Array} imagesNeedingSize - new images
 * @returns {undefined}
 */
export const compareAndFetchSizes = (componentId, imagesNeedingSize) => async (
  dispatch,
  getState,
  { api }
) => {
  try {
    dispatch(getImageSizeRequest(componentId, imagesNeedingSize));
    const shouldMakeApiCall = Array.isArray(imagesNeedingSize) && imagesNeedingSize.length;
    const contentSize = shouldMakeApiCall
      ? await api.misc.calculateImageSize(imagesNeedingSize)
      : [];
    dispatch(
      getImageSizeResponse(
        componentId,
        contentSize && contentSize.length ? contentSize : undefined
      )
    );
  } catch (error) {
    dispatch(getImageSizeFailure(error));
  }
};
